import * as React from "react"
import { graphql, useStaticQuery, Script, navigate } from "gatsby"
import Header from "../components/header"
import Footer from "../components/footer"
import Breadcrumbs from "../components/breadcrumbs"
import { UserInterfaceContext } from "../context/UserInterfaceContext"
import { Transition } from "@headlessui/react"
import LoadingSpinner from "../components/loading-spinner"
import classNames from "../utils/classnames"
import LocalMenu from "../components/local-menu"
import IWpMenuItem from "../interfaces/IWpMenuItem"
import hashRedirects from "../data/hash-redirects.json"
import isBrowser from "../utils/isBrowser"

interface ILayoutProps {
  children?: React.ReactNode
  breadcrumbs?: string | null | undefined
  localMenuItem: IWpMenuItem | null
  minHeight?: boolean
  marineCourse?: boolean | null | undefined
  ptsCourse?: boolean | null | undefined
}

export default function MainLayout(props: ILayoutProps): JSX.Element {
  const { children, breadcrumbs, localMenuItem, minHeight = true } = props
  const {
    setMegaMenuActive,
    showMainContent,
    showAwkward,
    mobileMenuOpen,
    setMobileMenuOpen,
    tocMobilePortalRef,
  } = React.useContext(UserInterfaceContext)
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  // watch pageHash for changes and rerun useEffect via dependency array
  let pageHash = ``
  if (isBrowser) {
    pageHash = window.location.hash
  }

  React.useEffect(() => {
    // check URL for specific page and hash combinations to redirect
    const path = window.location.pathname
    const hash = window.location.hash
    const redirect = hashRedirects[path] ? hashRedirects[path][hash] : undefined
    if (redirect) {
      navigate(redirect)
    }
  }, [pageHash])

  return (
    <>
      <div role="navigation">
        <a
          href="#main"
          className="sr-only focus:not-sr-only absolute bg-blue text-white p-4 block text-center"
        >
          Skip to content
        </a>
      </div>

      {/* <WelcomeHeader /> */}
      <Header siteTitle={data.site.siteMetadata?.title || `Georgian College`} />

      <nav className="sticky top-0 lg:static z-[9999] bg-blue min-h-[10px]">
        {localMenuItem && <LocalMenu localMenuItem={localMenuItem} />}
      </nav>

      {breadcrumbs && breadcrumbs !== `` && (
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      )}

      <div
        ref={tocMobilePortalRef}
        id="table-of-contents-mobile-portal"
        className="2xl:hidden block sticky top-14 lg:top-0 h-0 w-full z-[999]"
      />

      {showAwkward && (
        <Transition
          as={React.Fragment}
          show={showAwkward}
          appear
          enter="transform transition duration-50"
          enterFrom="opacity-0 translate-y-12"
          enterTo="opacity-100 translate-y-0"
          leave="transform transition duration-50"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-12"
        >
          <div className="flex flex-col gap-2 text-center lg:text-left lg:flex-row lg:container lg:mx-auto items-center justify-center m-4">
            <LoadingSpinner className="mx-auto lg:mx-0 h-8 w-8 lg:h-6 lg:w-6" />
            <div className="text-gray-300">
              well this is awkward
              <span className="whitespace-nowrap mx-2">¯\_(ツ)_/¯</span>
              something seems to be slowing us down, please wait
            </div>
          </div>
        </Transition>
      )}

      <div
        className={classNames(
          `gutenberg-page`,
          minHeight ? `min-h-[1000px]` : ``
        )}
        onMouseEnter={(): void => setMegaMenuActive(``)}
      >
        {/* <Transition
          as={React.Fragment}
          show={showMainContent}
          appear
          enter="transform transition duration-75"
          enterFrom="opacity-0 translate-y-12"
          enterTo="opacity-100 translate-y-0"
          leave="transform transition duration-75"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-12"
        > */}
        <article
          id="main"
          className="relative page gutenberg-content"
          role="main"
          aria-label="Page Content"
        >
          {children}
        </article>
        {/* </Transition> */}
      </div>

      <Footer marineFooter={props.marineCourse} conedFooter={props.ptsCourse} />

      {/* mobile menu backdrop */}
      <Transition
        show={mobileMenuOpen}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div
          className="bg-black opacity-25 fixed top-0 right-0 left-0 bottom-0 z-[9999]"
          onClick={(): void => setMobileMenuOpen(false)}
        />
      </Transition>

      {/* <WelcomeBack /> */}
      {/* <Script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-NXMV4BC');`}</Script> */}
    </>
  )
}
